import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from "./App";



// console.log("Environment:", process.env.REACT_APP_ENV);
// console.log("AUTO LEARN API Root URL:", process.env.REACT_APP_AUTOLEARN_API_ROOT);



// ReactDOM.createRoot(document.getElementById('root')).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );


// ReactDOM.createRoot(document.getElementById('root')).render(
//   <App />
// );


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />

);


